(function(){
  if (window.__brfAudit2) return; window.__brfAudit2 = true;
  var doc = document, root = doc.documentElement;

  /* 7. phones: hide floating buttons while scrolling, back 900ms after it stops */
  var phone = window.matchMedia ? matchMedia('(max-width:749px)') : null, st = null;
  window.addEventListener('scroll', function(){
    if (!phone || !phone.matches) return;
    if (!root.classList.contains('brf-scrolling')) root.classList.add('brf-scrolling');
    clearTimeout(st); st = setTimeout(function(){ root.classList.remove('brf-scrolling'); }, 900);
  }, {passive: true});

  /* 8. card names: drop fabric widths ("45\"", "60”", "150cm", "150 cm wide") from the name shown on cards.
     The full name stays in the title attribute and on the product page. */
  var SIZE = /\s*[,–-]?\s*\(?\b\d{2,3}(?:\.\d)?\s?(?:"|”|''|″|in(?:ch(?:es)?)?\b|cm\b)\s*(?:wide\b)?\)?/gi;
  var DIM = /\b\d+(?:\.\d+)?\s?(?:cm|m)?\s*[x×]\s*\d+(?:\.\d+)?\s?(?:cm|m)\b/gi;
  function tidy(el){
    if (!el || el.__brfT) return; el.__brfT = 1;
    var full = el.textContent.trim(); if (!full) return;
    /* piece sizes such as "49cm x 78cm" (remnants) stay in the name (Abid, 2026-10-26) */
    var keep = [];
    var short = full.replace(DIM, function(m){ return '\u0001' + (keep.push(m) - 1) + '\u0002'; }).replace(SIZE, ' ').replace(/\s+,/g, ',').replace(/,\s*,/g, ',').replace(/\s{2,}/g, ' ').replace(/^[\s,–-]+|[\s,–-]+$/g, '').replace(/\u0001(\d+)\u0002/g, function(_, i){ return keep[+i]; }).trim();
    if (short && short !== full && short.length > 8) {
      if (!el.getAttribute('title')) el.setAttribute('title', full);
      if (el.childElementCount === 0) el.textContent = short;
    }
  }
  function cards(){ [].forEach.call(doc.querySelectorAll('.product-item__title,.brf-card__title,.brf-ucard__title'), tidy); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', cards); else cards();
  if (window.MutationObserver) {
    var t = null;
    new MutationObserver(function(){ clearTimeout(t); t = setTimeout(cards, 60); }).observe(doc.documentElement, {childList: true, subtree: true});
  }
})();
